import type { ReactNode } from 'react';
import { useAuth } from '@repletoryreach/sdk-auth';
import { PhoneDefaultsProvider } from '@repletoryreach/sdk-ui/inputs';

/**
 * Every phone field in the console assumes one country for a number typed
 * without a country code: the organisation's default country (Settings,
 * Organisation), else its billing country. There is no per-person setting
 * yet; the provider is where one would be read first if there were.
 */
export function PhoneDefaults({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const org = user?.org;
  return (
    <PhoneDefaultsProvider country={org?.default_country ?? org?.country_iso ?? null}>
      {children}
    </PhoneDefaultsProvider>
  );
}
